<template>
    <div class="app" id="app">
        <keep-alive>
            <!--使用keep-alive会将页面缓存-->
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
import '@/assets/css/base.css';
import '@/assets/css/form.scss';

export default {
    name: 'App',
    mounted() {
        //解决IOS在微信浏览器的黑条问题
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
            window.history.pushState({}, 'title', '#')
        }
        // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
        // window.onbeforeunload = function (e) {
        //     var storage = window.localStorage;
        //     storage.clear()
        // }
    },
};
</script>
<style>
html,
body,
.app {
    height: 100%;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 12px;
}
#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
